// ------------- VARIABLES ------------- //
var ticking = false;
var isFirefox = (/Firefox/i.test(navigator.userAgent));
var isIe = (/MSIE/i.test(navigator.userAgent)) || (/Trident.*rv\:11\./i.test(navigator.userAgent));
var scrollSensitivitySetting = 20; //Increase/decrease this number to change sensitivity to trackpad gestures (up = less sensitive; down = more sensitive) 
var slideDurationSetting = 600; //Amount of time for which slide is "locked"
var currentSlideNumber = 0;
var totalSlideNumber = $(".slide").length;
var previousScroll = 0; 

// If ie, add class so can apply fixes in css (change vh to %)
if(isIe) {
  $('.HomePage').addClass('isIE');
}

// ------------- DETERMINE DELTA/SCROLL DIRECTION ------------- //
function parallaxScroll(evt, destination) {

	// Determine type of event
	if(evt.type == 'wheel' || evt.type == 'DOMMouseScroll') {

		if (isFirefox) {
			//Set delta for Firefox
			delta = evt.detail * (-120);			
		} else if (isIe) {
			//Set delta for IE
			delta = -evt.deltaY;
		} else {
			//Set delta for all other browsers
			delta = evt.wheelDelta;
		}
	}

	if(evt.type == 'click') {		
		delta = destination;
	}

	if(evt.type == 'scroll') {
		//delta = evt.
		var currentScroll = $(document).scrollTop();
		if(currentScroll > previousScroll) {
			// scrolling down / move panels up
			delta = previousScroll - currentScroll;
		} else {
			// scrolling up / move panels down
			delta = -currentScroll;
		}
	}

	if (ticking != true) {

		// wheel and finger scrolling
		if (delta <= -scrollSensitivitySetting) {
			//Down scroll
			ticking = true;
			if (currentSlideNumber !== totalSlideNumber - 1) {
				currentSlideNumber++;        
			}
			nextItem();
			slideDurationTimeout(slideDurationSetting);
		}
		if (delta >= scrollSensitivitySetting) {
			//Up scroll
			ticking = true;
			if (currentSlideNumber !== 0) {
				currentSlideNumber--;
			}
			previousItem(); 
			slideDurationTimeout(slideDurationSetting);
		}

		// clicking
		if(evt.type == 'click') {
			if( destination >= currentSlideNumber ) {
				// scrolling down
				ticking = true;
				currentSlideNumber = destination;
				clickedScrollDown();
				slideDurationTimeout(slideDurationSetting);
			} else if( destination <= currentSlideNumber ) {
				// scrolling up
				ticking = true;
				currentSlideNumber = destination;
				clickedScrollUp();  
				slideDurationTimeout(slideDurationSetting);
			}
		}

		updateActiveIndicator();
		colourSwap();
		ProductBackgroundGrowth(); 
    
	}
}

// ------------- SET TIMEOUT TO TEMPORARILY "LOCK" SLIDES ------------- //
function slideDurationTimeout(slideDuration) {
  setTimeout(function() {
    ticking = false;
  }, slideDuration);
}


// ------------- ADD SCROLL EVENT LISTENER ------------- //
var _ = require('lodash');
var mousewheelEvent = isFirefox ? "DOMMouseScroll" : "wheel";
window.addEventListener(mousewheelEvent, _.throttle(parallaxScroll, 100), false);

// click event
$('.slide_button').click(function(evt) {
  	parallaxScroll(evt, $(this).index());
});

window.addEventListener('scroll', _.throttle(parallaxScroll, 100), false);

// ------------- SLIDE MOTION ------------- //

// for scrolls

function nextItem() {
  var $previousSlide = $(".slide").eq(currentSlideNumber - 1);
  $previousSlide.removeClass("up-scroll").addClass("down-scroll");
}

function previousItem() {
  var $currentSlide = $(".slide").eq(currentSlideNumber);
  $currentSlide.removeClass("down-scroll").addClass("up-scroll");
}

// for clicks

function clickedScrollDown() {
  // update slides with index less than current
  var $allPrevious = $('.slide:lt(' + (currentSlideNumber) + ')');
  $allPrevious.removeClass("up-scroll").addClass("down-scroll");
}

function clickedScrollUp() {
  // update new current
  var $currentSlide = $(".slide").eq(currentSlideNumber);
  $currentSlide.removeClass("down-scroll").addClass("up-scroll");

  // update slides with index greater than current
  var $allNext = $('.slide:gt(' + (currentSlideNumber) +')');
  $allNext.removeClass("down-scroll").addClass("up-scroll");
}

// --- UPDATE ELEMENTS -- //

function updateActiveIndicator() {
  // Update slide nav indicator
  $('.slide_nav .slide_button').removeClass('active');
  $('.slide_nav .slide_button:eq('+ currentSlideNumber +')').addClass('active');

  // Update active slide - for content hide/show
  $('.slide').removeClass('active');
  $('.slide:eq(' + currentSlideNumber + ')').addClass('active');
}

// Swap colour of nav and footer - white/black
function colourSwap() {
  if( currentSlideNumber === totalSlideNumber - 1 ) {
    $('nav.menu, .menu__trigger, footer').addClass('white');
  } else {
    $('nav.menu, .menu__trigger, footer').removeClass('white');
  }
}

function ProductBackgroundGrowth() {

	// Hide the product bg image, want to close this when slide changes
	$('.slide_product .product_bg.open').removeClass('open');

	var $currentSlide = $(".slide").eq(currentSlideNumber);
	var slideID = $currentSlide.attr('id');
	var productBg = $('.slide_product .product_bg[data-slide="' + slideID + '"]');

	if(productBg.length > 0) {
		productBg.addClass('open');
	}
  
}